import {
  SET_SELECTED_LOCATION,
  SET_SELECTED_LOCATION_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  loading: false,
  error: false,
};

const LocationReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_SELECTED_LOCATION: {
      return {
        ...state,
        selectedLocationId: action.locationId,
        selectLocationName: action?.locationName,
      };
    }
    case SET_SELECTED_LOCATION_SUCCESS: {
      return { ...state, loading: true };
    }

    default:
      return state;
  }
};

export default LocationReducer;
